module.exports = __webpack_public_path__ + "static/img/bx1.c923b3ca.png";